// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { store } from "../../../store/store";
import { fetchCompanyProviders } from "../../../store/companies/companiesActions";

export async function providersLoader({ params }) {
  const { companyId } = params;

  if (!companyId) {
    return null;
  }

  await store.dispatch(fetchCompanyProviders(companyId));
  return null;
}

providersLoader.hydrate = true;
